<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "MainLayout",
  components: {},
  data: function () {
    return {
      drawMenu: null,
      userMap: {},
    };
  },
  created() {},
  methods: {
    getMenu() {},
  },
};
</script>
